var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6523_29689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6154 52.6409L55.1302 61.1261L79.115 85.111L87.6002 76.6258L63.6154 52.6409Z",
    fill: "#75748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9994 40.4387C77.7194 40.4387 83.9994 34.1587 83.9994 26.4387C83.9994 24.1187 83.3594 21.9587 82.3594 20.0387L71.5594 30.8387L65.5994 24.8787L76.3994 14.0787C74.4794 13.0787 72.3194 12.4387 69.9994 12.4387C62.2794 12.4387 55.9994 18.7187 55.9994 26.4387C55.9994 28.0787 56.3194 29.6387 56.8394 31.0787L49.4394 38.4787L42.3194 31.3587L45.1594 28.5187L39.5194 22.8787L47.9994 14.3987C43.3194 9.71867 35.7194 9.71867 31.0394 14.3987L16.8794 28.5587L22.5194 34.1987H11.2394L8.39941 37.0387L22.5594 51.1987L25.3994 48.3587V37.0387L31.0394 42.6787L33.8794 39.8387L40.9994 46.9587L11.3594 76.5987L19.8394 85.0787L65.3594 39.5987C66.7994 40.1187 68.3594 40.4387 69.9994 40.4387Z",
    fill: "#75748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6523_29689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.f3aaece2979ff3fe4e574b002aa2e25a.svg";
export { ForwardRef as ReactComponent };